module.exports = __webpack_public_path__ + "assets/img/edit.26534271.svg";